<template>
<v-col cols="12" md="9" lg="8" class="mx-auto" style="padding-bottom:150px;">
  <v-row class="mx-0">

    <v-col cols="12" sm="11" md="10" lg="9" class="text-center mx-auto pagetitle pt-15">
      <v-icon class="d-none d-md-flex" style="" color="primary">mdi-wallet-bifold-outline</v-icon>
      <v-icon class="d-md-none" style="" color="primary">mdi-wallet-bifold-outline</v-icon>
      <h2 class="mt-3 ml-4 primary--text font-oxa">Comptes Publics</h2>
      <small class="font-papyrus d-block mt-5" @click="fetchPublicWallets()">
        Dans un souci de transparence, le solde des Comptes Publics est accessible à tous.
      </small>
      <v-divider class="my-5"></v-divider>
      <div class="text-left">
      Actuellement, les comptes publics ne sont pas utilisés, 
      mais ils existent afin de montrer qu'il serait possible
      de mettre en place la Monnaie Pirate à grande échelle, en tant que monnaie officielle.
      <br><br>
      Ces comptes sont remplis tous les jours directement via la création monétaire,
      et proportionellement au nombre d'utilisateurs total du système.
      <br><br>
      Ils captent chacun 1/3 de la création monétaire quotidienne de chaque utilisateur.
      <br>
      C'est pour cette raison que vous recevez seulement 0.33 PRT par jour sur votre compte courant, et non 1 PRT.
      <br><br>
      Le système pirate est donc déjà prêt à fonctionner à grande échelle, dès que le monde sera prêt pour ça !
      </div>
      <v-divider class="my-5"></v-divider>
      <br>
      <span class="grey--text">
      Pour être exact, le Trésor Public n'est pas totalement inutilisé :<br>il sert à financer les codes de parrainage lors de l'inscription.
      </span>
      <br>
      <br>
    </v-col>

    <template v-for="user in $store.state.app.publicWallets">
      <v-col :key="user._id" cols="12" md="6" class="">
        <h2 class="pa-3 text-center font-papyrus primary--text" 
            style="border:1px dashed #fbc02d; border-radius:0px;border-radius:8px;">
          <v-icon color="primary">mdi-wallet</v-icon><br>
          {{ user.name }}
        </h2>
        <div class="d-block text-center">
          <v-icon color="primary darken-1" large class="mb-1">mdi-chevron-down</v-icon>
        </div>
        <WalletCard :ownerName="user.name" :wallet="user.walletMain"></WalletCard>
        <!-- <div class="d-block text-center">
          <v-icon color="grey darken-4" large class="pa-0" 
                  style="margin-top:-3px; margin-bottom:-3px; transform: rotate(90deg)">
                  mdi-pipe
          </v-icon>
        </div>
        <WalletCard :ownerName="user.name" :wallet="user.walletsDeposit[0]"></WalletCard> -->
      </v-col>
    </template>
    <v-col cols="12" md="6" class="">
      Dans un monde où le PRT deviendrait la monnaie officielle, 
      le Trésor Public servirait à couvrir les dépenses liées au fonctionnements de l'Etat.
      <br><br>
      (fonctionnaires, entretien des bâtiments, travaux public, etc)
    </v-col>
    <v-col cols="12" md="6" class="">
      Dans un monde où le PRT deviendrait la monnaie officielle, 
      la Caisse Commune d'Investissement serait chargée de réaliser des prêts personnels et professionnels,
      soumis à remboursement (ou non).
      <br><br>
      (achat maison, voiture, lancement d'activité, etc)
    </v-col>
  </v-row>
</v-col>
</template>

<style>
  .icon-link{
    background-color: #1e1e1e;
    border-radius: 50%;
    margin: -6px;
    z-index: 5;
    border: 1px solid #393939;
  }
</style>

<script>
import WalletCard from '@/components/wallet/WalletCard.vue'
//import UserPage from '@/components/entity/UserPage.vue'
//import axios from "axios"

export default {
  name: 'public-wallets',
  props: [],
  components: {
    WalletCard
  },
  data: () => ({
    
  }),
  mounted: async function(){ 
    this.$store.dispatch('app/incStat', '/public-wallets')
    this.$store.dispatch('app/fetchPublicWallets')
  },
  methods: {
  },
  watch: {
      
      
  }
  
}
</script>
